import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ModuleName } from 'src/app/middleware/common/Enum/common.enum';
import { AddEmailActionComponent } from 'src/app/middleware/common/addEmailAction/addEmailAction.component';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.scss']
})
export class EmailComponent implements OnInit {
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  OfficeIDList: any=[];
  myOfficeID: any;

  @Input() mainModulename: string;
 
  getTagListResponseHolder: any;
  All3CEmailList:any=[]=[];
  All3CBroadCastList:any=[]=[];
  showEmail:boolean=true;
  showBroadCast:boolean=false;
  title:string="View Broadcasting";

  constructor(private dialog: MatDialog,private taskService: SettingService,
    private statusConst: StatusConstant, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses,private loaderService: LoaderService,
    private toastr: ToastrService,) {
      const encryptedtoken = sessionStorage.getItem('userToken');
      this.databaseId = sessionStorage.getItem('databaseId');
      this.organizationId = sessionStorage.getItem('organizationID');
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey,encryptedtoken);   
      this.currentUser = jwt_decode(token); 
      var offices=JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if(oe.isMyoffice==true)
        this.myOfficeID=oe.officeID;
      }); 
   }

  ngOnInit(): void {
    this.getActivityEMails3C();
  }

  addEmailAction() {
    const dialogRef = this.dialog.open(AddEmailActionComponent, {     
      data: {
        moduleName:this.mainModulename,      
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result!=null && result!=undefined){
       this.getActivityEMails3C();
      }      
    });
  } 

   // get Activity List
   getActivityEMails3C() {
    var cType=0;
    if(this.mainModulename=="Core"){
      cType=1;
    }
    if(this.mainModulename=="Contact"){
      cType=2;
    }
    if(this.mainModulename=="Company"){
      cType=3;
    }
    var ReqModel={
      cid:Number(sessionStorage.getItem('transactionID')),      
      cType:cType,
      userID:this.currentUser.UID,
      organizationID:Number(this.organizationId),
      officeID: this.myOfficeID,
      databaseId:Number(this.databaseId)      
     }
     this.loaderService.show();
     this.taskService.getActivityEMails(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.getTagListResponseHolder = response;
        this.loaderService.hide();
        if (this.getTagListResponseHolder.status == this.statusConst.statusSuccess) {          
          this.getTagListResponseHolder = response.data.emails;                  
          this.All3CEmailList = this.getTagListResponseHolder;
          if(this.All3CEmailList!=null){
            this.All3CEmailList.forEach(e => {
              if(e.isRead==true){
                e.senmessage="Opened";
              }
              if(e.isRead==false){
                if(e.isSent==true){
                  e.senmessage= "Sent";
                }else{
                  e.senmessage= "Failed";
                }
              }
              
            });
          }
        }
        else {
          this.All3CEmailList=[];
          this.loaderService.hide();    
        }
      }else{
        this.All3CEmailList=[];
        this.loaderService.hide();
      }
    });
  }

  removeActivityEmail(type: any) {  
    var message = `Are you sure you want to delete?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData
    });
    dialogRef.beforeClosed().subscribe(async dialogResult => {
      if (dialogResult) {
        this.loaderService.show();
        var cType=0;
        if(this.mainModulename=="Core"){
          cType=1;
         }
        if(this.mainModulename=="Contact"){
          cType=2;
         }
        if(this.mainModulename=="Company"){
          cType=3;
         }
        var ReqModel = {
          mailIDs:[type.mailID],
          cid:Number(sessionStorage.getItem('transactionID')),      
          cType:cType,
          userID:this.currentUser.UID,
          organizationID:Number(this.organizationId),
          officeID: this.myOfficeID,
          databaseId:Number(this.databaseId)  
        }     
        this.taskService.removeActivityEmail(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            this.loaderService.hide();
            if (this.responseHolder.status == this.statusConst.statusSuccess) {             
              this.toastr.success('Activity Email deleted successfully.', '', {
                timeOut: 3000,
              });
              this.getActivityEMails3C();
              this.loaderService.hide();
            }
          }
          else{
            this.loaderService.hide();
          }
        });
      }
    });
   }

   
   changeToggle(event: any) {
     if(event.checked==true){  
      this.title= "View Broadcasting";  
      this.showEmail=false;
      this.showBroadCast=true;
      this.get3CBroadcastMessage();
     }
     if(event.checked==false){
      this.title= "View Broadcasting";
      this.showEmail=true;
      this.showBroadCast=false;
      this.getActivityEMails3C();     
     }
   }

   get3CBroadcastMessage(){
    var cType=0;
    if(this.mainModulename=="Core"){
      cType=1;
    }
    if(this.mainModulename=="Contact"){
      cType=2;
    }
    if(this.mainModulename=="Company"){
      cType=3;
    }
    var ReqModel={
      cid:Number(sessionStorage.getItem('transactionID')),      
      cType:cType,
      userID:this.currentUser.UID,
      organizationID:Number(this.organizationId),
      officeID: this.myOfficeID,
      databaseId:Number(this.databaseId)
     }
     this.loaderService.show();
     this.taskService.get3CBroadcastMessages(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.getTagListResponseHolder = response;
        this.loaderService.hide();
        if (this.getTagListResponseHolder.status == this.statusConst.statusSuccess) {          
          this.getTagListResponseHolder = response.data;                  
          this.All3CBroadCastList = this.getTagListResponseHolder;
          if(this.All3CBroadCastList.length>0){
            this.All3CBroadCastList.forEach(e => {
              if(e.isRead==true){
                e.senmessage="Opened";
              }
              if(e.isRead==false){
                if(e.isSent==true){
                  e.senmessage= "Sent";
                }else{
                  e.senmessage= "Failed";
                }
              }
              
            });
          }
        }
        else {
          this.All3CBroadCastList=[];
          this.loaderService.hide();    
        }
      }else{
        this.All3CBroadCastList=[];
        this.loaderService.hide();
      }
    });
   }
  
   
   resentBroadcastMessage(data:any) {  
    var message = `Are you sure you want to Resend?`;
    const title = `Confirm`;
    const confirm = `Resend`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData
    });
    dialogRef.beforeClosed().subscribe(async dialogResult => {
      if (dialogResult) {
        this.loaderService.show();        
        var ReqModel={
          iD:data.id,            
          userID:this.currentUser.UID,
          organizationID:Number(this.organizationId),
          officeID: this.myOfficeID,
          databaseId:Number(this.databaseId)
         }
         this.loaderService.show();
         this.taskService.resentBroadcastMessage(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.getTagListResponseHolder = response;
            this.loaderService.hide();
            if (this.getTagListResponseHolder.status == this.statusConst.statusSuccess) {          
              this.toastr.success('Resend successfully.', '', {
                timeOut: 3000,
              });
              this.get3CBroadcastMessage();
            }
            else {         
              this.loaderService.hide();    
            }
          }else{       
            this.loaderService.hide();
          }
        });
      }
    });
   }

   
}
